export enum TipoIntervento {
    Hardware = 1,
    Software = 2
}

export enum TipoAttrezzatura {
    NonSpecificato = 0,
    BiancoNero = 1,
    Colore = 2
}

export interface DestinatarioMatricola {
    idDestinatario: string,
    destinatario: string,
    matricole: Matricola[]
}

export interface Matricola {
    idSpecifica: string,
    codice: string,
    numeroMacchina: string,
    ubicazione: string,
    referente: string,
    descrizione: string,
    tipoAttrezzatura: TipoAttrezzatura   
}